import APIURL from "../axios";

export const getInStayRentalCategoriesAPI = async ({ room_uuid, lang }) => {
  return await APIURL.get(`/${room_uuid}/in-stay-rental/categories`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang,
    },
  });
};

export const getInStayRentalItemsAPI = async ({
  room_uuid,
  category_id,
  lang,
}) => {
  return await APIURL.get(
    `/${room_uuid}/in-stay-rental/categories/${category_id}/items`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        lang,
      },
    },
  );
};

// Order fields: see src/utils/inStayRental.js
export const createInStayRentalOrderAPI = async ({
  room_uuid,
  formData,
  lang,
}) => {
  return await APIURL.post(`/${room_uuid}/in-stay-rental/order`, formData, {
    headers: {
      Accept: "application/json",
      lang,
    },
  });
};
